import classNames from 'classnames'
import React from 'react'

import { i18n } from '~/i18n'

import CheckboxInput from '../../checkbox-input'

type Props = {
  checked: boolean
  onChange: (arg0: boolean) => void
  className?: string
}

export default function Checkbox(props: Props) {
  return (
    <CheckboxInput
      checked={props.checked}
      className={classNames('save-card', props.className)}
      label={i18n.t('components.save_card_on_file.label')}
      onChange={props.onChange}
    />
  )
}
